export const TITLE_OPTIONS = [
  {
    label: 'Mr',
    value: 'Mr',
  },
  {
    label: 'Mrs',
    value: 'Mrs',
  },
  {
    label: 'Ms',
    value: 'Ms',
  },
  {
    label: 'Miss',
    value: 'Miss',
  },
  {
    label: 'Mx',
    value: 'Mx',
  },
  {
    label: 'Dr',
    value: 'Dr',
  },
  {
    label: 'Rev',
    value: 'Rev',
  },
  {
    label: 'Sir',
    value: 'Sir',
  },
];

export const COUNTRY_OPTIONS = [
  {
    value: 'GB',
    label: 'United Kingdom',
  },
  {
    value: 'BE',
    label: 'Belgium',
  },
  {
    value: 'FR',
    label: 'France',
  },
  {
    value: 'DE',
    label: 'Germany',
  },
  {
    value: 'IE',
    label: 'Ireland',
  },
  {
    value: 'OT',
    label: 'Other',
  },
];

export type RegisterFormValues = {
  firstName: string;
  lastName: string;
  title: string | null;
  email: string;
  phoneNumber: string;
  password: string;
  confirmPassword: string;
  addressLine1: string;
  addressLine2: string;
  city: string;
  county: string;
  postcode: string;
  countryCode: string | null;
  marketingConsent: Set<string>;
};
export const registerFormInitialValues = {
  firstName: '',
  lastName: '',
  title: null,
  email: '',
  phoneNumber: '',
  password: '',
  confirmPassword: '',
  marketingConsent: new Set([]),
} as const;

export const registerFormInitialValuesWithAddress: RegisterFormValues = {
  ...registerFormInitialValues,
  addressLine1: '',
  addressLine2: '',
  postcode: '',
  county: '',
  city: '',
  countryCode: 'GB',
};

export type LoginFormValues = {
  email: string;
  password: string;
};
export const loginFormInitialValues: LoginFormValues = {
  email: '',
  password: '',
};

export type ForgotPasswordFormValues = {
  email: string;
};
export const forgotPasswordFormInitialValues: ForgotPasswordFormValues = {
  email: '',
};

export type ResetPasswordFormValues = {
  password: string;
  confirmPassword: string;
};
export const resetPasswordFormInitialValues: ResetPasswordFormValues = {
  password: '',
  confirmPassword: '',
};

export type RegisterGuestFormValues = {
  firstName: string;
  lastName: string;
  title: string | null;
  email: string;
  phoneNumber: string;
  password: string;
  confirmPassword: string;
  alternativePhoneNumber: string;
  addressLine1: string;
  addressLine2: string;
  city: string;
  county: string;
  postcode: string;
  countryCode: string | null;
  marketingConsent: Set<string>;
};
export const registerGuestFormInitialValues: RegisterGuestFormValues = {
  ...registerFormInitialValuesWithAddress,
  alternativePhoneNumber: '',
};

export type UpgradeGuestFormValues = {
  phoneNumber: string;
  alternativePhoneNumber: string;
  addressLine1: string;
  addressLine2: string;
  city: string;
  county: string;
  postcode: string;
  countryCode: string | null;
  firstName: string;
  lastName: string;
  title: string | null;
};
export const upgradeGuestFormInitialValues: UpgradeGuestFormValues = {
  phoneNumber: '',
  alternativePhoneNumber: '',
  addressLine1: '',
  addressLine2: '',
  postcode: '',
  county: '',
  city: '',
  countryCode: 'GB',
  firstName: '',
  lastName: '',
  title: null,
};

export type UpgradeOwnerFormValues = {
  ownerAccountNumber: string;
  postcode: string;
  lastName: string;
};
export const upgradeOwnerFormInitialValues: UpgradeOwnerFormValues = {
  ownerAccountNumber: '',
  postcode: '',
  lastName: '',
};

export type UpgradeAddressFormValues = {
  addressLine1: string;
  addressLine2: string;
  city: string;
  county: string;
  postcode: string;
  countryCode: string | null;
};
export const upgradeAddressFormInitialValues: UpgradeAddressFormValues = {
  addressLine1: '',
  addressLine2: '',
  postcode: '',
  county: '',
  city: '',
  countryCode: 'GB',
};

export const trimFormValues = (formData: { [key: string]: any }): { [key: string]: any } => {
  return Object.keys(formData).reduce(
    (acc, curr) => {
      acc[curr] = typeof formData[curr] === 'string' ? formData[curr].trim() : formData[curr];
      return acc;
    },
    {} as { [key: string]: any },
  );
};
